// extracted by css-extract-rspack-plugin
var _1 = true;
var _2 = "step-Fy9cY";
var _3 = "text-3iBl_";
export { _1 as "__esModule", _2 as "step", _3 as "text" }
export default { "__esModule": _1, "step": _2, "text": _3 }
